export default {
  v3SubmitErrBtnViewOrder: 'Siparişi Görüntüle',
  v3SubmitErrBtnBackHome: 'Ana Sayfa',
  v3SubmitErrBtnRetry: 'Tekrar Dene',
  v3SubmitErrBtnRelogin: 'Tekrar Giriş Yap',
  v3SubmitErrBtnSwitchPay: 'Ödeme Yöntemini Değiştir',
  v3SubmitErrBtnReorder: 'Yeniden Sipariş Ver',
  v3SubmitErrBtnSwitchServer: 'Sunucu Değiştir',
  v3SubmitErrBtnViewOrderStatus: 'Sipariş Durumu',
  v3SubmitErrBtnBackStore: 'Mağazaya Dön',
  v3SubmitErrBtnGoUpdate: 'Güncelle',
  v3SubmitErrBtnResubscribe: 'Yeniden Abone Ol',
  v3SubmitErrTipUpdateApp: 'Uygulama mağazasından güncelleyin',
  v3SubmitErrTipRelogin: 'Lütfen tekrar giriş yapın',

  v3SubmitErrMsg120009: 'Sipariş işlendi – oyundaki çantanı kontrol et.',
  v3SubmitErrMsg120003: 'Ürün bilgisi hatalı – yeniden seçin.',
  v3SubmitErrMsg120016: 'Çok fazla istek – birkaç saniye bekleyip yeniden dene.',
  v3SubmitErrMsg120025: 'İstek parametreleri hatalı – tekrar giriş yapıp dene.',
  v3SubmitErrMsg121012: 'Ödeme kanalı geçici olarak kullanılamıyor – başka bir yöntem dene.',
  v3SubmitErrMsg120012: 'Ağ kararsız – bağlantını kontrol et ve tekrar dene.',
  v3SubmitErrMsg120002: 'Oyun karakteri bulunamadı – önce bir karakter oluştur.',
  v3SubmitErrMsg121019: 'Sipariş bilgisi hatalı – yeni sipariş oluştur.',
  v3SubmitErrMsg120024: 'Ön kayıt hediyesi zaten alındı – tekrara gerek yok.',
  v3SubmitErrMsg120000: 'Oturum süresi doldu – tekrar giriş yap.',
  v3SubmitErrMsg120014: 'Sipariş numarası geçersiz – yeni sipariş oluştur.',
  v3SubmitErrMsg121001: 'Oyuna yükleme başarısız – daha sonra tekrar dene veya desteğe başvur.',
  v3SubmitErrMsg120015: 'Ödeme tutarı anormal – ürünü yeniden seç.',
  v3SubmitErrMsg120001: 'Sunucu eşleşmiyor – doğru sunucuya geç.',
  v3SubmitErrMsg120020: 'Ödeme kanalı hata döndü – başka bir yöntem dene.',
  v3SubmitErrMsg120010: 'Oyun yükleme işlevi geçici olarak kapalı – daha sonra dene.',
  v3SubmitErrMsg120006: 'Tutar doğrulaması başarısız – yeniden seç.',
  v3SubmitErrMsg121010: 'Sanal ortam yükleme isteği geçersiz – resmi sürümü kullan.',
  v3SubmitErrMsg120017: 'Sipariş numarası çift – ödendi mi kontrol et.',
  v3SubmitErrMsg120022: 'Ödeme geri araması doğrulaması başarısız – daha sonra dene.',
  v3SubmitErrMsg121000: 'Sistem meşgul – daha sonra dene.',
  v3SubmitErrMsg120011: 'Ürün kimliği hatalı – yeniden seç.',
  v3SubmitErrMsg121015: 'Ödeme tutarı doğrulaması başarısız – yeni sipariş oluştur.',
  v3SubmitErrMsg120004: 'Bu ödeme kanalı açık değil – başka bir yöntem seç.',
  v3SubmitErrMsg120005: 'Ödeme kanalı bakımda – başka bir yöntem kullan.',
  v3SubmitErrMsg120007: 'Platform kimliği geçersiz – tekrar giriş yap.',
  v3SubmitErrMsg120008: 'İstek parametreleri yetersiz – yeniden gönder.',
  v3SubmitErrMsg120013: 'Geliştirici sipariş numarası hatalı – yeni sipariş oluştur.',
  v3SubmitErrMsg120018: 'Ödeme risk kontrolü tarafından engellendi – doğrulama için desteğe başvurun.',
  v3SubmitErrMsg120019: 'Paket adı doğrulaması başarısız – resmi sürümü kullan.',
  v3SubmitErrMsg120021: 'Ürün kimliği doğrulaması başarısız – yeniden seç.',
  v3SubmitErrMsg120023: 'Ön kayıt hediyesi gönderim hatası – daha sonra kontrol et.',
  v3SubmitErrMsg120026: 'Hesap bulunamadı – hesap durumunu kontrol et.',
  v3SubmitErrMsg120030: 'Toplam stok yetersiz – başka bir ürün seç.',
  v3SubmitErrMsg120031: 'Bu ürün için satın alma limitini aştınız – ayarlayın.',
  v3SubmitErrMsg120032: 'Oyun sürümü çok eski – en son sürümü indir.',
  v3SubmitErrMsg120080: 'Vekalet ödeme risk kontrolü tarafından kısıtlandı – kendi ödeme yöntemini kullan.',
  v3SubmitErrMsg120081: 'Vekalet ödeme risk kontrolü tarafından geciktirildi – sonucu daha sonra kontrol et.',
  v3SubmitErrMsg121002: 'Sipariş önbelleği geçersiz – yeni sipariş oluştur.',
  v3SubmitErrMsg121003: 'Yükleme yapılandırması bulunamadı – desteğe başvurun.',
  v3SubmitErrMsg121004: 'Genişletilmiş parametreler yetersiz – yeniden gönder.',
  v3SubmitErrMsg121005: 'Önbelleğe yazma başarısız – daha sonra dene.',
  v3SubmitErrMsg121006: 'Önbellek okuma başarısız – daha sonra dene.',
  v3SubmitErrMsg121007: 'Yükleme türü yapılandırma hatası – desteğe başvurun.',
  v3SubmitErrMsg121011: 'Apple\'dan yeni alanlar algılandı – uygulamayı güncelle.',
  v3SubmitErrMsg121013: 'Yenileme siparişi bulunamadı – yeniden abone ol.',
  v3SubmitErrMsg121014: 'Yükleme parametresi şifre çözme başarısız – yeniden gönder.',
  v3SubmitErrMsg121017: 'Bu sipariş iade edildi – onay için desteğe başvurun.',
  v3SubmitErrMsg121018: 'Abonelik süresi doldu – yeniden abone ol.',
  v3SubmitErrMsg121020: 'Sipariş iptal edildi – yeni sipariş oluştur.',
  v3SubmitErrMsg121021: 'Google API hatası – daha sonra dene.',
  v3SubmitErrMsg121022: 'Erişim jetonu alınamadı – tekrar giriş yap.',
  v3SubmitErrMsg121023: 'Sipariş durumu anormal – yatırma durumunu kontrol et.',
  v3SubmitErrMsg121024: 'Sipariş onayı başarısız – daha sonra dene.'
};
